import { t } from '@localization/i18n';
import { FormFieldType, SelectFieldType } from '@/type';
import { ImageGalleryLightboxState } from '@type/imageGallery/ImageGalleryLightboxState';

export const gallerySorterOptions = [
  { label: t('common.sort-by-name-asc'), value: 'name_asc' },
  { label: t('common.sort-by-name-desc'), value: 'name_desc' },
  { label: t('common.sort-by-width-asc'), value: 'width_asc' },
  { label: t('common.sort-by-width-desc'), value: 'width_desc' },
  { label: t('common.sort-by-height-asc'), value: 'height_asc' },
  { label: t('common.sort-by-height-desc'), value: 'height_desc' },
  {
    label: t('common.sort-by-uploaded-date-asc'),
    value: 'uploadDate_asc',
  },
  {
    label: t('common.sort-by-uploaded-date-desc'),
    value: 'uploadDate_desc',
  },
];

export const galleryOrderSelectField: SelectFieldType = {
  type: FormFieldType.Select,
  name: 'galleryOrderSelect',
  label: t('common.order-by'),
  options: gallerySorterOptions,
};

export const imageGalleryLightBoxDefaultValue: ImageGalleryLightboxState = {
  isOpen: false,
  currentIndex: undefined,
  imageSources: [],
  imageId: undefined,
};
